<template><section><h2>Basic Funnel Chart 基础漏斗图</h2>
<block-demo tip="" source="const data = [
  { value: 3721, label: &quot;浏览网站&quot; },
  { value: 3006, label: &quot;放入购入车&quot; },
  { value: 2505, label: &quot;生成订单&quot; },
  { value: 2151, label: &quot;支付订金&quot; },
  { value: 1782, label: &quot;完成订单&quot; },
  { value: 1503, label: &quot;完成交易&quot; },
  { value: 1204, label: &quot;未完成交易&quot; },
]

const { Chart, Funnel, Tooltip, Legend } = qcharts

const chart = new Chart({
  container: &quot;#app&quot;,
})

chart.source(data, {
  row: &quot;label&quot;,
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const tooltip = new Tooltip()
const funnel = new Funnel({
  clientRect: {
    left: &quot;25%&quot;,
    top: &quot;10%&quot;,
    width: &quot;50%&quot;,
    height: &quot;80%&quot;,
  },
  align: &quot;center&quot;,
  formatter: (d) =&gt; `${d.value}`,
})
  .style(&quot;guideline&quot;, true)
  .style(&quot;guideText&quot;, true)
  .style(&quot;polygon:hover&quot;, (polygon, dataOrigin, index) =&gt; {
    return { opacity: 0.5 }
  })
const legend = new Legend()
chart.append([funnel, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3721</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"浏览网站"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3006</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"放入购入车"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2505</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"生成订单"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2151</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"支付订金"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1782</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"完成订单"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1503</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"完成交易"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1204</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"未完成交易"</span> },
]

<span class="hljs-keyword">const</span> { Chart, Funnel, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"label"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> funnel = <span class="hljs-keyword">new</span> Funnel({
  <span class="hljs-attr">clientRect</span>: {
    <span class="hljs-attr">left</span>: <span class="hljs-string">"25%"</span>,
    <span class="hljs-attr">top</span>: <span class="hljs-string">"10%"</span>,
    <span class="hljs-attr">width</span>: <span class="hljs-string">"50%"</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-string">"80%"</span>,
  },
  <span class="hljs-attr">align</span>: <span class="hljs-string">"center"</span>,
  <span class="hljs-attr">formatter</span>: <span class="hljs-function">(<span class="hljs-params">d</span>) =&gt;</span> <span class="hljs-string">`<span class="hljs-subst">${d.value}</span>`</span>,
})
  .style(<span class="hljs-string">"guideline"</span>, <span class="hljs-literal">true</span>)
  .style(<span class="hljs-string">"guideText"</span>, <span class="hljs-literal">true</span>)
  .style(<span class="hljs-string">"polygon:hover"</span>, (polygon, dataOrigin, index) =&gt; {
    <span class="hljs-keyword">return</span> { <span class="hljs-attr">opacity</span>: <span class="hljs-number">0.5</span> }
  })
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
chart.append([funnel, tooltip, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>